export default "__VITE_ASSET__b9dc1f2e__"